import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  export: () => __(translations.exportCollectionsPerLocalisationPage.okay, 'Export'),
  langue: () => __(translations.exportCollectionsPerLocalisationPage.langue, 'Langue'),
  title: () => __(translations.exportCollectionsPerLocalisationPage.alertTitle, 'Export collections per localisation'),
  stockLocalisation: () => __(translations.exportCollectionsPerLocalisationPage.stockLocalisation, 'Stock Localisation'),
  collection: () => __(translations.exportCollectionsPerLocalisationPage.collection, 'Collection'),
  fr: () => __(translations.exportCollectionsPerLocalisationPage.fr, 'Français'),
  en: () => __(translations.exportCollectionsPerLocalisationPage.en, 'Anglais'),
};
